import React from "react";
import { Link } from "react-router-dom";

import { FaXTwitter } from "react-icons/fa6";
import {
	MdMarkEmailRead,
	MdOutlineKeyboardDoubleArrowRight,
} from "react-icons/md";
import {
	MdPhoneInTalk,
	MdOutlineKeyboardDoubleArrowLeft,
} from "react-icons/md";
import {
	FaFacebookF,
	FaInstagram,
	FaMapMarkerAlt,
	FaSnapchatGhost,
	FaTiktok,
	FaYoutube,
} from "react-icons/fa";
import { FooterBg } from "../../assets/img";

// import css style
import "./Footer.css";
import { useTranslation } from "react-i18next";
import SocialMediaLinks from "../socialMediaLinks/SocialMediaLinks";

const Footer = ({ navigation, footerLogo, socialLink, addressData }) => {
	const { t, i18n } = useTranslation();

	const socialItems = [
		{ type: "facebook", url: socialLink?.facebook, icon: <FaFacebookF /> },
		{
			type: "twitter",
			url: socialLink?.twiter,
			icon: <FaXTwitter />,
		},
		{ type: "youtube", url: socialLink?.youtube, icon: <FaYoutube /> },
		{
			type: "instagram",
			url: socialLink?.instegram,
			icon: <FaInstagram />,
		},
		{ type: "snapchat", url: socialLink?.snapchat, icon: <FaSnapchatGhost /> },
		{ type: "tiktok", url: socialLink?.tiktok, icon: <FaTiktok /> },
	];

	return (
		<footer className=' relative  pt-8 md:px-12 px-6 bg-main_color'>
			<section className='grid md:grid-cols-2 grid-cols-1 '>
				<div className='md:mb-0 mb-10'>
					<img loading='lazy' className=' w-28 mb-3' src={footerLogo} alt='' />
					<p className=' text-[16px] md:w-[70%] w-full font-normal text-start text-slate-300 mb-3'>
						{t("webSite name")}
					</p>

					<SocialMediaLinks socialItems={socialItems} />
				</div>

				<section className='grid md:grid-cols-2 grid-cols-1 ga-4  z-10 relative'>
					<div>
						<h6 className=' text-xl font-medium mb-3 text-white'>
							{t("site map")}
						</h6>

						<ul className='grid md:grid-cols-1 grid-cols-2 md:mb-0 mb-10'>
							{navigation?.map((item) => (
								<li className='flex justify-start items-center gap-1  mb-2'>
									{i18n?.language === "ar" ? (
										<MdOutlineKeyboardDoubleArrowLeft className=' text-second_color' />
									) : (
										<MdOutlineKeyboardDoubleArrowRight className=' text-second_color' />
									)}
									<Link
										key={item?.type}
										className=' custom-transition text-slate-300 hover:text-second_color text-lg font-normal '
										to={item.to}>
										{i18n?.language === "ar" ? item?.name_ar : item?.name_en}
									</Link>
								</li>
							))}
						</ul>
					</div>

					<div>
						<h6 className='text-xl font-medium mb-3 text-white'>
							{t("address")}
						</h6>

						<ul>
							<li>
								<div className=' flex justify-start items-center gap-1 custom-transition text-slate-300 hover:text-second_color text-lg font-normal mb-3'>
									<div className='w-6'>
										{" "}
										<FaMapMarkerAlt className=' text-second_color' />
									</div>

									<a
										className=' truncate'
										href={addressData?.main_address}
										target='_blank'
										rel='noreferrer'>
										{addressData?.main_address}
									</a>
								</div>
							</li>
							<li>
								<div className=' flex justify-start items-center gap-1 custom-transition text-slate-300 hover:text-second_color text-lg font-normal mb-3'>
									<div className='w-6'>
										{" "}
										<FaMapMarkerAlt className=' text-second_color' />
									</div>

									<a
										className=' truncate'
										href={addressData?.sub_address}
										target='_blank'
										rel='noreferrer'>
										{addressData?.sub_address}
									</a>
								</div>
							</li>
							<li>
								<div className='flex justify-start items-center gap-1 custom-transition text-slate-300 hover:text-second_color text-lg font-normal mb-3'>
									<div className='w-6'>
										{" "}
										<MdPhoneInTalk className=' text-second_color' />
									</div>
									<a
										href={`tel:${addressData?.phone}`}
										target='_blank'
										rel='noreferrer'>
										{addressData?.phone}
									</a>
								</div>
							</li>
							<li>
								<div className=' flex justify-start items-center gap-1 custom-transition text-slate-300 hover:text-second_color text-lg font-normal mb-3'>
									<div className='w-6'>
										{" "}
										<MdMarkEmailRead className=' text-second_color' />
									</div>
									<a
										href={`mailto:${addressData?.email}`}
										target='_blank'
										rel='noreferrer'>
										{addressData?.email}
									</a>{" "}
								</div>
							</li>
							<li>
								<div className=' flex justify-start items-center gap-1 custom-transition text-slate-300 hover:text-second_color text-lg font-normal '>
									<div className='w-6'>
										{" "}
										<MdMarkEmailRead className=' text-second_color' />
									</div>

									<a
										href={`mailto:${addressData?.sales_email}`}
										target='_blank'
										rel='noreferrer'>
										{addressData?.sales_email}
									</a>
								</div>
							</li>
						</ul>
					</div>
				</section>
			</section>
			<div className='footer-map'>
				<img loading='lazy' src={FooterBg} alt='' />
			</div>

			<section className='flex justify-center items-center relative z-10 w-full  pt-2 pb-1 border-t-[1px] border-t-[#f0f0f01a]'>
				<p className='text-sm text-second_color font-light '>
					جميع الحقوق محفوظة لشركة راج
				</p>
			</section>
		</footer>
	);
};

export default Footer;
